import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount, ref } from "vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { nextTick } from "vue";
import Viewport from "@/store/modules/Viewport";
import useResize from "@/composables/useResize";

export default /*#__PURE__*/_defineComponent({
  __name: 'Parallax',
  props: {
  speed: {
    type: Number,
    default: 1,
  },
  speedMobile: {
    type: Number,
    default: 1,
  },
  rotation: {
    type: Number,
    default: 0,
    required: false
  },
  scrub: {
    type: Number,
    default: 0.75,
    required: false
  },
  scrubStart: {
    type: String,
    default: 'top bottom',
    required: false
  },
  scrubEnd: {
    type: String,
    default: 'bottom top',
    required: false
  }
},
  setup(__props) {

gsap.registerPlugin(ScrollTrigger)

const props = __props

const root = ref<HTMLElement | null>(null)
let timeline: gsap.core.Timeline
let latestSpeed: number | null = null

const { registerResize, unregisterResize } = useResize();

onMounted(() => {
  initParallax()

  registerResize(onResize);
})
onBeforeUnmount(() => {
  unregisterResize();
})

const onResize = () => {
  const speed = getSpeed();
  if (latestSpeed !== speed) {
    initParallax()
  }
}
const getSpeed = () => {
  return Viewport.isDesktop ? props.speed : props.speedMobile
}

const clearTimeline = (reset = true) => {
  timeline?.scrollTrigger?.kill(reset)
  timeline?.kill()
}

const initParallax = async() => {
  clearTimeline()

  await nextTick()

  latestSpeed = getSpeed();

  if (latestSpeed !== 0) {
    timeline = gsap.timeline({
      scrollTrigger: {
        trigger: root.value,
        start: props.scrubStart,
        end: props.scrubEnd,
        scrub: props.scrub,
        // markers: true
      },
      defaults: { ease: "none", duration: 1 }
    })
    timeline.fromTo(
      root.value,
      { 
        y: (latestSpeed * 10) + 'vw',
      },
      { 
        y: (latestSpeed * -10) + 'vw',
        duration: 1,
      },
      0
    ),
    timeline.fromTo(
      root.value,
      { 
        rotate: props.rotation,
      },
      { 
        rotate: 0,
        duration: 0.5,
        ease: 'power1.out'
      },
      0
    )
  }
}

onBeforeUnmount(() => {
  if(timeline) {
    timeline.scrollTrigger?.kill(false)
    timeline.kill()
    timeline = null
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "parallax",
    ref_key: "root",
    ref: root
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})